import ReportDetailsHeader from 'Components/ReportDetailsHeader';
import React from 'react'
import { Card, CardHeader, Row, Col, TabContent, TabPane } from 'reactstrap';
import OtherDetailsComponent from './partials/OtherDetailsComponent';
import { ReportingTypeConstant } from 'shared/constants';
import { useDocumentTitle } from 'Components/useDocument.hooks';
import { RootState } from 'index';
import { useSelector } from 'react-redux';
interface EconDeckAdditionalInformationType {
    toggleTab?: (value: number) => void,
    activeTab?: number,
    setErrorMessage: any
    editReportBool: boolean
}

const EconAddInformation = ({
    toggleTab,
    activeTab,
    setErrorMessage,
    editReportBool
}: EconDeckAdditionalInformationType) => {
    /** State variables start*/
    useDocumentTitle('Econ Ship Additional Information - ecoSAIL');
    const { CurrentReport } = useSelector((state: RootState) => state.Reporting);
    const currentVesselReport = CurrentReport?.data?.vessel_reporting_information ?? null;
    /** State variables end*/
    return (
        <Card className='p-0 mb-0 border-0'>
            <CardHeader className='p-2'>
                <div className="text-center">
                    <Row>
                        <Col>
                            <h4 className="page_title pos-start mb-0">Additional Information</h4>
                        </Col>
                        <Col>
                            <ReportDetailsHeader />
                        </Col>
                    </Row>
                </div>
            </CardHeader>
            <div id="basic-pills-wizard" className="twitter-bs-wizard">
                <TabContent activeTab={1} className="tabHeight">
                    <TabPane tabId={
                        currentVesselReport?.reporting_type === ReportingTypeConstant.ATSEA ? 1 : 0
                    }>
                        <OtherDetailsComponent
                            toggleTab={toggleTab}
                            activeTab={activeTab}
                            setErrorMessage={setErrorMessage}
                            editReportBool={editReportBool}
                        />
                    </TabPane>
                </TabContent>
            </div>
        </Card>
    )
}

export default EconAddInformation;
